import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import AdminPage from './pages/AdminPage';
import { RequireAuth } from './components/RequireAuth';
import { APP_MENU } from './menuItems';
import { FillQuestionare } from './components/FillQuestionare';
import { useMediaQuery } from './hooks/useMediaQuery'; 
import Login from './pages/Login';
import PartnerNewToken from './pages/PartnerNewToken';



function App() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)'); 
  const nextTheme = prefersDarkMode ? 'dark' : 'light';
  const { t } = useTranslation(); 

  useEffect(() => {
    const linkElement = document.createElement('link');
    const styleOverwrite = document.createElement('link');

    linkElement.rel = 'stylesheet';
    linkElement.href = `/static/css/${nextTheme}.css`;
    document.head.appendChild(linkElement);

    styleOverwrite.rel = 'stylesheet';
    styleOverwrite.href = `/static/css/${nextTheme}-colors.css`;
    document.head.appendChild(styleOverwrite);

    return () => {
      document.head.removeChild(linkElement);
      document.head.removeChild(styleOverwrite);
    };
  }, [nextTheme]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/tokens" />} />
      <Route path="/login" element={<Login />} />
      {
        // Create routes from APP_MENU
        APP_MENU.map(menu => {
          const content = menu.content;
          if (!content) return null;

          return (
            <Route
              key={menu.id}
              path={menu.path}
              element={
                <RequireAuth requiredRoles={menu.roles}>
                  <AdminPage title={t(menu.titleKey)}>{content}</AdminPage>
                </RequireAuth>
              }
            />
          );
        })
      }
      
      <Route path="/questionare/:id" element={<FillQuestionare />} />
      <Route path="/partnerpage/:id" element={<PartnerNewToken />} />
    </Routes>
  );
}

export default App;
